import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import * as React from "react";
import {
  BooleanInput,
  DateTimeInput,
  ReferenceInput,
  SelectInput,
  TextInput,
  required,
  useRecordContext,
  SelectArrayInput,
  AutocompleteInput,
  NumberInput
} from "react-admin";
import { trasformDateString } from "src/common/UtilFunctions";
import { CustomerRoleEnum, AdminRoleEnum } from "../../common/enum/RoleEnum";
import { StatusEnum } from "src/common/enum";
import { AddressTabContent } from "src/components/address";
import { PhoneInput } from "src/components/input/PhoneInput";
import { Edit, FormTab, IfCanAccess, TabbedForm } from "src/enterprise/ra-rbac";
import Transformer from "../../common/Transformer";
import { formatDateTime } from "src/common/UtilFunctions";
import { UserEditComponent } from "./UserComponent";
import { UserHistoryTypeEnumIcons } from "src/common/enum";

export const UserEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["createdAt", "updatedAt", "customerRoles", "adminRoles", "histories", "id", "website", "email", "lastSessionAt", "confirmedAt"],
      update: {
        verified: data.verified !== null ? data.verified.toString() : "false",
        confirmed: data.confirmed !== null ? data.confirmed.toString() : "false",
        roles: [...data.customer_roles, ...data.admin_roles]
      },
    });
    return data;
  };

  const filterToQuery = (searchText) => ({
    "search": searchText,
  });

  return (
    <Edit
      component={UserEditComponent}
      mutationMode="pessimistic"
      transform={transform}
      actions={null}
    >
      <TabbedForm>
        <FormTab label="General" name="general">
          <Grid container rowSpacing={1} columnSpacing={3}>
            <Grid container item sm={12} rowSpacing={1} columnSpacing={2}>
              <Grid item sm={12} md={3}>
                <TextInput disabled source="id" />
              </Grid>
            </Grid>
            <Grid item sm={12} md={6} lg={3}>
              <TextInput source="first_name" validate={required()} />
            </Grid>
            <Grid item sm={12} md={6} lg={3}>
              <TextInput source="last_name" validate={required()} />
            </Grid>
            <Grid item sm={12} md={6}>
              <TextInput source="email" type="email" disabled />
            </Grid>

            <Grid item sm={12} md={6}>
              <PhoneInput sx={{ width: "100%" }} source="phone" label="Phone" />
            </Grid>

            <Grid item sm={12} md={6}>
              <PhoneInput
                sx={{ width: "100%" }}
                source="mobile"
                label="Mobile"
                required={false}
              />
            </Grid>

            <Grid item sm={12} md={6} lg={3}>
              <DateTimeInput source="last_session_at" disabled/>
            </Grid>

            <Grid item sm={12} lg={3}>
              <TextInput source="company" />
            </Grid>
            <Grid item sm={12} lg={3}>
              <TextInput source="website" />
            </Grid>
            
          </Grid>
        </FormTab>
        <FormTab label="Administrative" name="administrative">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} md={6}>
              <SelectInput source="status" choices={StatusEnum} validate={required()} />
            </Grid>
            <Grid item sm={12} md={3}>
              <BooleanInput source="confirmed"/>
            </Grid>
            <Grid item sm={12} md={3}>
              <DateTimeInput source="confirmed_at" disabled/>
            </Grid>
            <Grid item sm={12} md={6}>
              <TextInput
                source="notes"
                multiline
                resettable
                sx={{
                  "#notes": { minHeight: "87.5px", height: "100%" },
                }}
              />
            </Grid>
            <Grid item sm={12} md={6}>
              <Grid container rowSpacing={1} columnSpacing={2}>
                <Grid item md={6}>
                  <SelectArrayInput source="customer_roles" label="Customer Roles" choices={CustomerRoleEnum} />
                </Grid>
                <Grid item md={6}>
                  <SelectArrayInput source="admin_roles" label="Admin Roles" choices={AdminRoleEnum} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </FormTab>

        <FormTab label="Addresses" name={"addresses"}>
          <IfCanAccess action="write" resource="admin/addresses.*">
            <AddressTabContent />
          </IfCanAccess>
        </FormTab>

        <FormTab label="Histories" name="histories">
          <HistoriesTable/>
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};


const HistoriesTable = () => {
  const record = useRecordContext();
  const rows = record ? (record.histories ? record.histories : []) : [];

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Paper sx={{width: "100%"}}>
      <TableContainer sx={{border: "1px solid #ebebeb", borderRadius: "8px", boxShadow: "0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)"}}>
        <Table sx={{ minWidth: 650, width: "100%" }} size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                Type
              </TableCell>
              <TableCell>
                Message
              </TableCell>
              <TableCell>
                Created At
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...rows].slice().reverse().slice(page * rowsPerPage, (page+1) * rowsPerPage).map((row) => {
              let typeEnum = UserHistoryTypeEnumIcons.find((type) => type.id === row.type);

              return (
                <TableRow key={row.id}>
                  <TableCell sx={{width: "0px",whiteSpace: "nowrap"}}>
                    {typeEnum && typeEnum.icon}
                  </TableCell>
                  <TableCell  sx={{width: "100%"}}>
                    {row.message}
                  </TableCell>
                  <TableCell sx={{width: "0px",whiteSpace: "nowrap"}}>
                    {formatDateTime(row.created_at)}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 20, 50]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
};
